export const getRailsMessage = () => {
  const flashContainer = document.querySelectorAll('#flashes-data');

  if (flashContainer.length) {
    const flash = flashContainer[0];
    let flashObject = {
      text: flash.getAttribute('data-message'),
      id: 'rails-flash-message',
      key: 'rails-flash-message',
      kind: flash.getAttribute('data-kind'),
    };

    if (flash.getAttribute('data-button-key') && flash.getAttribute('data-button-url')) {
      const button = {
        button: {
          key: flash.getAttribute('data-button-key'),
          url: flash.getAttribute('data-button-url'),
        },
      };

      flashObject = {
        ...button,
        ...flashObject,
      };
    }

    return flashObject;
  }
  return null;
};
